export default __webpack_public_path__ + "static/media/onlymurders2.378f92bc.jpeg";